<template>
  <div class="worksheet" style="max-width: 1000px; margin: auto;">
    <div style="margin-top: 50px;" v-if="loading" v-loading="loading" element-loading-spinner="atom-audit-loader">
    </div>
    <div v-if="!loading">
      <el-button class="pull-right print-hidden" round style="margin-top: 0px;" icon="mdi mdi-details" size="mini" @click="saveWorksheet">Download</el-button>
      <div v-for="(worksheet, index) in worksheets" :key="worksheet.patientNumber" class="page-break" style="margin-bottom: 50px;">
        <TenantReportHeader v-if="index === 0"></TenantReportHeader>
        <h1 class="header-row">Inpatient Review Worksheet</h1>
        <InpatientWorksheet :worksheet="worksheet"></InpatientWorksheet>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { format, parseISO } from 'date-fns'
  import InpatientWorksheet from './InpatientWorksheet.vue'
  import TenantReportHeader from '@/views/reports/printable/TenantReportHeader.vue'

  import axios from '@/utilities/axios-global'
  export default {
    name: 'Worksheets',
    props: ['drgTableIds'],
    data() {
      return {
        loading: true,
        format: format,
        parseISO: parseISO,
        dropdownsNeeded: ['RecommendationTypes', 'RecommendationRecordTypes', 'RecommendationCodeGroups', 'clients']
      }
    },
    components: {
      InpatientWorksheet,
      TenantReportHeader
    },
    methods: {
      ...mapActions('managedLists/tenantSetup/', ['GET_TENANT_SETUP']),
      saveWorksheet() {
        window.print()
      }
    },
    created: async function () {
      const ids = {
        ids: this.drgTableIds ? this.drgTableIds : this.$route.query.ids
      }
      const url = this.baseApiUrl + '/reviews/inpatient/worksheets?includeDrgWorksheets=true&includeFyiWorksheets=true&includeNoChangeWorksheets=true'
      const response = await Promise.all([axios.post(url, ids), this.GET_TENANT_SETUP()])
      this.worksheets = response[0].data
      this.loading = false
    },
    computed: {
      ...mapState('user/', [
        'baseApiUrl'
      ])
    }
  }
</script>

<style scoped>
  @media print {
    .page-break {
      display: block;
      page-break-after: always;
    }

    .print-hidden {
      display: none;
    }
  }
</style>